import React from "react"
import feather from "feather-icons"
import LampIcon from "../../images/icons/lamp.svg"
import Logo from "../../images/logo.svg"
import Building from "../../images/icons/building.svg"
import Domain from "../../images/icons/domain.svg"

interface MarkupType {
  __html: any
}

function createMarkup(markup: any): MarkupType {
  return { __html: markup }
}

interface IconProps {
  type: "original" | "feather"
  name: string
  attr?: object
  className?: string
}

const OriginalElement = (props) => {
  switch (props.name) {
    case "lamp":
      return <LampIcon />
    case "logo":
      return <Logo />
    case "building":
      return <Building />
    case "domain":
      return <Domain />
    default:
      return <React.Fragment />
  }
}

const FeatherElement = (props) => (
  <span
    dangerouslySetInnerHTML={createMarkup(
      feather.icons[props.name].toSvg(props.attr)
    )}
    className={props.className}
  ></span>
)

const IconC: React.FC<IconProps> = (props) => {
  return (
    <React.Fragment>
      {props.type == "original" && (
        <span className={props.className}>
          <OriginalElement {...props} />
        </span>
      )}
      {props.type == "feather" && <FeatherElement {...props} />}
    </React.Fragment>
  )
}

export default IconC
